import { FilterGroup } from '../Tools/FilterGroup';
import { StyleFilter } from '../Filters/StyleFilter';
import { RoomTypeFilter } from '../Filters/RoomTypeFilter';
import { FiltersController } from '../Tools/FiltersController';
import { FiltersWidget } from '../FiltersWidget';

export class StyleFilterWidget extends FilterGroup {
    constructor(container: string) {
        super();
        this.id = 'style';
        this.name = 'Shopping list';
        this.icon = 'fas fa-lg fa-shopping-cart';
        this.resource = 'allAssets';
        this.showUnavailable = true;
        this.sort = { width: 0 }
        this.filtersFunction = 'updateTemplates';
        this.filters = [
            new StyleFilter(this),
            new RoomTypeFilter(this)
        ]
        this.container = container;
        this.controller = new FiltersController();
    }

    generateStringFilter() {
        let stringFilters = "";
        //let filters = FilterGroup.filters;

        /*if (filters.style !== null && filters.style.length > 0) {
            stringFilters += '&q.styles._id.in=';
            for (let i = 0; i < filters.style.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += filters.style[i]._id;
            }
        }

        if (filters.roomType !== null && filters.roomType.length > 0) {
            stringFilters += '&q.environment.roomTypes.in=';
            for (let i = 0; i < filters.roomType.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += filters.roomType[i]._id;
            }
        }*/

        if (FilterGroup.filters.assets && FilterGroup.filters.assets.length > 0) {
            stringFilters += '&q._id.in=' + FilterGroup.filters.assets;

            stringFilters += '&order=_id';
        }
        return stringFilters;
    };

    getProjectResultsTableHtml(): string {
        if (!FilterGroup.projectResults || FilterGroup.projectResults.length === 0) return '';

        return FilterGroup.projectResults.map((item, index) => {
            return `
                <tr data-index="${index}" style="${FilterGroup.isTemplateSelected(item)}; cursor: pointer;">
                    <td>${item.name}</td>
                </tr>
            `;
        }).join('');
    }

    getProjectResultsHtml(): string {
        setTimeout(() => {
            this.controller.addEventListener('click', (event) => {
                const tr = (event.target as Element).closest('tr');
                if (tr && tr.dataset.index !== undefined) {
                    const index = parseInt(tr.dataset.index, 10);
                    const item = FilterGroup.projectResults![index];
                    FilterGroup.selectTemplate(item).then(() => this.updateProjectResultsHtml());
                }
            }, "project-results-tbody");

            this.controller.addEventListener('mousedown', () => {
                FilterGroup.replaceWithCurrentAssets();
            }, 'replaceWithCurrentAssets');
        });
        return `
            <div>
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="text-align: center;">Résultats</th>
                        </tr>
                    </thead>
                    <tbody id="project-results-tbody">
                        ${this.getProjectResultsTableHtml()}
                    </tbody>
                </table>
            </div>
            <!-- PAGINATION -->
            <div id="pagination-container" style="background:none;height:24px;background-color : #efefef">
                ${this.getStyleFilterPaginationHtml()}
            </div>
            <div>
                <button id="replaceWithCurrentAssets" class="btn-default" title="Remplacer par la shopping list">
                    <i class="fas fa-lg fa-sync-alt"></i>
                    <span style="margin-left: 10px;">Remplacer par la shopping list</span>
                </button>
            </div>
        `;
    }

    updateProjectResultsHtml(): void {
        const container = document.getElementById('project-results');
        if (container) {
            this.controller.removeEventListener('click', 'replaceWithCurrentAssets');
            this.controller.removeEventListener('click', 'project-results-tbody');
            this.controller.removeEventListener('click', 'previous');
            this.controller.removeEventListener('click', 'next');

            container.innerHTML = this.getProjectResultsHtml();
        }
    }

    html(): void {
        this.isDestroyed = false;
        FilterGroup.changeProjectPage(FilterGroup.currentPage).then(() => {
            let func = () => {
                let html = this.filtersHtml() + `
                <div>
                    <div style="min-height: 200px;">
                        ${FilterGroup.projectResults && FilterGroup.projectResults.length > 0 ? `
                        <div style="margin-bottom:10px; margin-top: 10px; padding:0;width:100%; border-top: #737373 solid 1px;" id="project-results">
                            ${this.getProjectResultsHtml()}
                        </div>
                        ` : ''}
                    </div>
                </div>
                `;
                let container = document.getElementById(this.container);
                if (!container) {
                    return;
                }
                container.innerHTML = html;
            }
            if (FilterGroup.selectedTemplate) {
                FilterGroup.selectTemplate(FilterGroup.selectedTemplate).then(() => func());
            } else {
                func();
            }
        });
    }

    getStyleFilterPaginationHtml(): string {
        setTimeout(() => {
            this.controller.addEventListeners('click', (e) => {
                e.preventDefault();
                const element = e.target as HTMLElement;
                const page = parseInt(element.getAttribute('data-page')!);
                if (!isNaN(page) && page !== FilterGroup.pagination.currentPage && !element.classList.contains('disabled')) {
                    FilterGroup.changeProjectPage(page).then(() => this.updateProjectResultsHtml());
                }
            }, 'pagination-number');

            this.controller.addEventListener('click', (e) => {
                e.preventDefault();
                if (FilterGroup.pagination.currentPage > 1) {
                    FilterGroup.changeProjectPage(FilterGroup.pagination.currentPage - 1).then(() => this.updateProjectResultsHtml());
                }
            }, 'previous');

            this.controller.addEventListener('click', (e) => {
                e.preventDefault();
                if (FilterGroup.pagination.currentPage < FilterGroup.pagination.nbPages) {
                    FilterGroup.changeProjectPage(FilterGroup.pagination.currentPage + 1).then(() => this.updateProjectResultsHtml());
                }
            }, 'next');
        });
        return `
            <ul class="designer-filters pagination">
                <li class="${FilterGroup.pagination.currentPage === 1 ? 'disabled' : ''}">
                    <a id="previous" aria-label="Previous">
                        <span aria-hidden="true">&laquo;</span>
                    </a>
                </li>
                ${FilterGroup.pagination.currentPage > 1 ? `
                <li>
                    <a class="pagination-number" data-page="1">${FilterGroup.pagination.list[0].index}</a>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage > 2 ? `
                <li>
                    <a class="pagination-number" data-page="2">${FilterGroup.pagination.list[1].index}</a>
                </li>
                ` : ''}
                
                ${FilterGroup.pagination.currentPage > 5 ? `
                <li>
                    <span>...</span>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage > 4 ? `
                <li>
                    <a class="pagination-number" data-page="${FilterGroup.currentPage - 2}">${FilterGroup.pagination.currentPage - 2}</a>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage > 3 ? `
                <li>
                    <a class="pagination-number" data-page="${FilterGroup.currentPage - 1}">${FilterGroup.pagination.currentPage - 1}</a>
                </li>
                ` : ''}

                <li class="active">
                    <span>${FilterGroup.pagination.currentPage}</span>
                </li>

                ${FilterGroup.pagination.currentPage < FilterGroup.pagination.list.length - 2 ? `
                <li>
                    <a class="pagination-number" data-page="${FilterGroup.currentPage + 1}">${FilterGroup.pagination.currentPage + 1}</a>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage < FilterGroup.pagination.list.length - 3 ? `
                <li>
                    <a class="pagination-number" data-page="${FilterGroup.currentPage + 2}">${FilterGroup.pagination.currentPage + 2}</a>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage < FilterGroup.pagination.list.length - 4 ? `
                <li>
                    <span>...</span>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage < FilterGroup.pagination.list.length - 1 ? `
                <li>
                    <a class="pagination-number" data-page="${FilterGroup.pagination.list.length - 1}">
                        ${FilterGroup.pagination.list.length - 1}
                    </a>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage < FilterGroup.pagination.list.length ? `
                <li>
                    <a class="pagination-number" data-page="${FilterGroup.pagination.list.length}">
                        ${FilterGroup.pagination.list.length}
                    </a>
                </li>
                ` : ''}

                <li class="${FilterGroup.pagination.currentPage === FilterGroup.pagination.nbPages ? 'disabled' : ''}">
                    <a id="next" aria-label="Next">
                        <span aria-hidden="true">&raquo;</span>
                    </a>
                </li>
            </ul>
        `;
    }

    destroy(): void {
        super.destroy();
    }
}